// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"3c491ac4","64":"f42ba7a2","120":"d2af4b91","216":"d6070960","453":"f9868307","565":"922bcfdd","598":"75b3ca3b","719":"ec3233b9","811":"3c1f1242","845":"c5e68891"}[chunkId] + ".chunk.js";
};